import { SUBSCRIPTION_FORM_KEYS } from "utils/constants";
import BankAccount from "./BankAccount";
import EmancipationCertificate from "./EmancipationCertificate";
import Id from "./Id";
import LegalRepresentativeProof from "./LegalRepresentativeProof";

const generateProofForm = ({
  showEmancipationCertificate = false,
  showLegalRepresentativeProof = false,
} = {}) => ({
  [SUBSCRIPTION_FORM_KEYS.PROOF.ID]: Id,
  [SUBSCRIPTION_FORM_KEYS.PROOF.BANK_ACCOUNT]: BankAccount,
  ...(showEmancipationCertificate && {
    [SUBSCRIPTION_FORM_KEYS.PROOF.EMANCIPATION_CERTIFICATE]:
      EmancipationCertificate,
  }),
  ...(showLegalRepresentativeProof && {
    [SUBSCRIPTION_FORM_KEYS.PROOF.LEGAL_REPRESENTATIVE_PROOF]:
      LegalRepresentativeProof,
  }),
});

export default generateProofForm;
